import { Link } from "gatsby"
import React from "react"
import Image from "./image"

const Header = props => {
  const { headerData, isMusic = false } = props

  return (
    <header
      style={{
        marginBottom: `1.45rem`,
      }}
    >
      <div style={{}}>
        <h1>
          <Link to="/" className="rv-flex rv-gap-2 rv-items-center header-link">
            <Image
              alt={`Rahul Vagadiya`}
              fileName={isMusic ? "rahul-flipped.png" : "rahul.png"}
              className="rv-rounded-full header-image"
              style={{
                width: "35px",
                height: "35px",
              }}
            />
            {headerData.name}
          </Link>
        </h1>

        <div className="bio">{headerData.description}</div>
      </div>
    </header>
  )
}
export default Header
